import { useTranslation } from 'react-i18next';
import { StyledUnmappedVariable } from './styles';
import Select from '__components/Inputs/Select';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';
import {
  type UnmappedVariableOption,
  type UnmappedVariableWithFields,
} from './helpers';
import { getDataQAForInput } from '__components/Inputs/helpers';

type UnmappedVariableRowProps = UnmappedVariableWithFields & {
  onChange: (fieldForMapping: UnmappedVariableOption) => void;
};

export const UnmappedVariableRow = ({
  variable,
  fieldsForMapping,
  onChange,
}: UnmappedVariableRowProps) => {
  const { t } = useTranslation();

  return (
    <StyledUnmappedVariable
      columns={2}
      gap="15px"
      data-qa-unmapped-variable-id={variable.id}
    >
      <TextEllipsisWithTooltip data-qa="unmapped-variable-name">{`${variable.name}`}</TextEllipsisWithTooltip>
      <Select
        placeholder={t('Select Field to add Rule')}
        onChange={onChange}
        options={fieldsForMapping}
        {...getDataQAForInput('field-to-add-rule', 'dropdown')}
      />
    </StyledUnmappedVariable>
  );
};
